import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Blindaje global de imágenes: si alguna foto llegara a fallar, evitamos el
// ícono de "imagen rota" y mostramos un fondo de marca discreto en su lugar.
window.addEventListener(
  "error",
  (e) => {
    const el = e.target;
    if (el && el.tagName === "IMG" && !el.dataset.fallbackApplied) {
      el.dataset.fallbackApplied = "1";
      el.style.background =
        "linear-gradient(135deg,#EEF5F2 0%,#A8E6CF33 50%,#81D4FA33 100%)";
      el.style.objectFit = "cover";
    }
  },
  true
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
